angular.module('app.directives.schedule').directive('hostRestrictionsSettings', () => {
  return {
    restrict: 'E',
    scope: {
      contentSettings: '=',
    },
    template: require('./host-restrictions-settings.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/host-restrictions-settings.js